const validEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i;
const validHouseNumberStreetLineRegx = /^(?!\s*$)[a-zA-Z0-9#\-.,'/\s]+$/i;
const validPostCode = /^(?!\s*$)[a-zA-Z0-9\s,.'-]{1,8}$/i;
const validCityRegex = /^[A-Z][a-zA-Z\s,.'-]+$/i;
const validBusinessNameRegex = /^(?!\s*$)[a-zA-Z0-9\s()_-]*$/;
// const validTreatmentNameRegex = /^(?!\s*$)[a-zA-Z0-9\s()_.-]*$/;
const validTreatmentNameRegex = /^(?!\s*$)[a-zA-Z0-9\s()_.\-/:&,+'’'‘’]*$/;
const validPhoneNumberRegex = /^(?:\d{4} \d{3,10}|\d{5} \d{3,9}|\d{8,15})$/;
const notOnlySpaceRegex = /.*\S.*/;
const validNameOnly= /^[a-z\u00C0-\u024F\s.'\-’]+$/i;

export const VALIDATION_REGEX = {
    email: validEmail,
    houseNoStreetLine: validHouseNumberStreetLineRegx,
    postcode: validPostCode,
    city: validCityRegex,
    businessName: validBusinessNameRegex,
    phoneNumber: validPhoneNumberRegex,
    notOnlySpaces: notOnlySpaceRegex,
    treatmentName: validTreatmentNameRegex,
    validName:validNameOnly
}